import { type FC } from "react";
import { PageOptions } from "../../types/page";
import ErrorIcon from "../../components/icons/ErrorIcon";
import { useTranslation } from "../../contexts/useTranslation";
import Navbar from "../../components/Navbar";
import ArrowLeftIcon from "../../components/icons/ArrowLeftIcon";
import { Slot, Templated } from "../../templating";
interface ErrorPageProps {
  navigate: (pageOptions: PageOptions) => void;
  isFullscreen: boolean;
}

const ErrorPage: FC<ErrorPageProps> = ({ navigate, isFullscreen }) => {
  const { translate } = useTranslation();

  return (
    <Templated id="lastbot-error-page">
      <>
        <Slot name="navbar">
          <Navbar isFullscreen={isFullscreen}>
            <button
              type="button"
              onClick={() => navigate({ page: { type: "landing" } })}
              className="-ml-1 text-lastbot-icon-muted cursor-pointer"
            >
              <ArrowLeftIcon />
            </button>
          </Navbar>
        </Slot>
        <div className="flex-1 flex flex-col px-4 text-lastbot-on-surface items-center justify-center text-center">
          <Slot name="error-icon"><ErrorIcon /></Slot>
          <div className="text-md font-medium pt-2 pb-6">
            <Slot name="form-error">{translate("something_went_wrong")}</Slot>
          </div>
          <Slot name="back-button">
            <button
              type="button"
              onClick={() => navigate({ page: { type: "landing" } })}
              className="mt-1 underline cursor-pointer"
            >
              {translate("back_to_start")}
            </button>
          </Slot>
        </div>
      </>
    </Templated>
  );
};

export default ErrorPage;
